import React, { useEffect } from "react";
import styles from "./styles/LandingMobile.module.css";
import { useNavigate } from "@tanstack/react-router";
// Для NavigateOptions может потребоваться импорт, если он доступен

import useWindowWidth from "@shared/hooks/useWindowWidth"; // Импортируем хук

const MOBILE_BREAKPOINT = 768; // Определяем breakpoint

const LandingMobile: React.FC = ({}) => {
  const navigate = useNavigate();
  const windowWidth = useWindowWidth();

  useEffect(() => {
    if (windowWidth > MOBILE_BREAKPOINT) {
      navigate({ to: "/", replace: true });
    }
  }, [windowWidth]);

  const handleGuestLogin = () => {
    navigate({ to: "/demo-mobile", replace: true });
  };

  return (
    <div className={styles.landingMobileContainer}>
      <button className={styles.guestLoginButtonMobile} onClick={handleGuestLogin}></button>
    </div>
  );
};

export default LandingMobile;
